module.exports = __webpack_public_path__ + "img/activities_off_icon.e40b7dbf.svg";